import { PURGE } from "redux-persist";

var initialState = {
  faqsResponse: null,
};

const FAQ = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE:
      return initialState;

    case "SET_FAQS_RESPONSE":
      return {
        ...state,
        faqsResponse: payload,
      };

    case "RESET_STORE":
      return (state = initialState);

    default:
      return state;
  }
};

export default FAQ;